import { render, staticRenderFns } from "./worksInfo.vue?vue&type=template&id=61b55c1b&"
import script from "./worksInfo.vue?vue&type=script&lang=js&"
export * from "./worksInfo.vue?vue&type=script&lang=js&"
import style0 from "./worksInfo.vue?vue&type=style&index=0&id=61b55c1b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports